import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { IWebhookResponseSchema } from "./webhooksApi.types";

const useGetAllWebhooksService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  filters,
}: IGetAllServiceProps) => {
  const allWebhooksService = useQuery<IWebhookResponseSchema>({
    queryKey: [...CACHE_KEYS.WEBHOOKS, page, per_page, filters],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.WEBHOOKS,
        searchParams: {
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allWebhooksService },
  };
};

export { useGetAllWebhooksService };
